import React, { Component } from 'react';
export default class Loader extends Component {
  render() {
    return (
      <div className="row loader">
        <img src="/img/loader.svg" />
      </div>
    );
  }
}
